// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import BootstrapVue from 'bootstrap-vue'
import firebase from 'firebase/app'
import { configDev, configProd } from './firebase/config'

import Croppa from 'vue-croppa'
import 'vue-croppa/dist/vue-croppa.css'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/en'

import store from './store'
import common from './utils/common'

import VueAnalytics from 'vue-analytics'
import VModal from 'vue-js-modal'

Vue.use(BootstrapVue)
Vue.use(Croppa)
Vue.use(ElementUI, { locale })
Vue.config.productionTip = false
Vue.use(VModal)

if (location.hostname === 'selmane.life') {
  firebase.initializeApp(configProd)
  Vue.use(VueAnalytics, {
    id: 'UA-127002896-2',
    router
  })
} else {
  firebase.initializeApp(configDev)
  Vue.use(VueAnalytics, {
    id: 'UA-127002896-1',
    router
  })
}

/* eslint-disable no-new */
new Vue({
  beforeCreate () {
    if (location.pathname === '/Terms' || location.pathname === '/Privacy') {
      router.push(location.pathname)
    } else {
      this.$store.dispatch('service/init')
      this.$store.dispatch('service/unSubscribe')
      store.dispatch('dispatch/setData', false)
      store.dispatch('dispatch/setLoading', true)
      store.dispatch('authUser/init', false)
      store.dispatch('register/register', false)
      store.dispatch('dispatch/setAuth', false)
      store.dispatch('authUser/authState')
      this.$store.dispatch('service/subscribe').then(() => {
      })
    }
  },
  el: '#app',
  router,
  store,
  firebase,
  common,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js